import { Directive, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';

@Directive({ selector: '[insertion]' })
export class InsertionDirective implements OnInit {
    private elm!: HTMLInsSelectElement;

    @Output() public insertion = new EventEmitter<any>();

    public constructor(private elmRef: ElementRef) {
        this.elm = this.elmRef.nativeElement;
    }

    public ngOnInit(): void {
        this.elm.keyboardActive = false;
    }

    @HostListener('keydown', ['$event'])
    protected onKeyDown(event: KeyboardEvent): void {
        if (!this.elm.classList.contains('is-open')) {
            if (event.code === 'ArrowUp') {
                event.preventDefault();
                this.elm.selectPreviousItem();
            }

            if (event.code === 'ArrowDown') {
                event.preventDefault();
                this.elm.selectNextItem();
            }
        }
    }

    @HostListener('keyup', ['$event'])
    protected onKeyUp(event: KeyboardEvent): void {
        if (!this.elm.classList.contains('is-open')) {
            if (event.code === 'Enter') {
                event.preventDefault();
                if (this.elm.value) {
                    const detail = { value: this.elm.value ?? null };
                    this.insertion.emit({ ...event, detail });
                    this.elm.value = null;
                    this.elm.setActiveItem(0);
                }
            }
            if (event.code === 'Space') {
                event.preventDefault();
                this.elm.open();
            }
        }
    }

    @HostListener('insSelect', ['$event'])
    protected onSelect(event: Event): void {
        if (this.elm.classList.contains('is-open')) {
            this.insertion.emit(event);
        }

        this.elm.setActiveItem(0);
        this.elm.value = null;
    }

    @HostListener('insBlur')
    protected onBlur(): void {
        this.elm.value = null;
        this.elm.setActiveItem(0);
    }
}
